import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AllocatorProfileIndexPage from 'buyside/components/presentation/AllocatorProfileIndexPage/allocatorProfileIndexPage';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

import { allocatorProfilesUrl } from 'buyside/util/urlHelper';

const AllocatorProfileIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="allocator profiles index">
      <Router basename={allocatorProfilesUrl()}>
        <AllocatorProfileIndexPage />
      </Router>
    </ErrorBoundary>
  );
};

export default AllocatorProfileIndexPageRoot;
